module.exports = __webpack_public_path__ + "static/media/oyster.ac31217d.png";